import styled from 'styled-components'
import { Drawer } from 'vaul'

import { Title } from '@radix-ui/react-dialog'

import { alpha } from '@probatix/common/utils/color'

import { COLORS } from '@probatix/common/constants/colors'

import { DRAWER_BORDER_RADIUS } from '@probatix/common/constants/design'

export const StyledDrawerRoot = styled(Drawer.Root)``

export const StyledDrawerContentContainer = styled.div`
  width: 100%;                     
  margin-left: auto; 
  margin-right: auto;
  overflow-y: hidden; 
  padding: 2rem 1rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`

export const StyledDrawerPortal = styled(Drawer.Portal)``

export const StyledDrawerOverlay = styled(Drawer.Overlay)`
  background-color: ${alpha(COLORS.BLACK, 0.4)};
  inset: 0;
  position: fixed;
`

interface IDrawerContent {
  open: boolean;
}

export const StyledDrawerContent = styled(Drawer.Content) <IDrawerContent>`
  left: 0;                        
  right: 0;   
  bottom: 0px !important;                         
  max-height: calc(80vh); 
  display: flex;                  
  flex-direction: column;         
  position: fixed;    
  border: 1px solid ${COLORS.ALICE_BLUE}; 
  border-width: 0px;
  border-top-right-radius: ${DRAWER_BORDER_RADIUS};
  border-top-left-radius : ${DRAWER_BORDER_RADIUS};
  background-color: ${COLORS.WHITE}; 

  & > div > div > div.container {
    overflow-y: scroll;
    max-height: 70vh;
    position: relative;
  }

  &:focus-visible {
    border: 0px;
    outline: 0px;
  } 
`

export const StyledDrawerHandle = styled(Drawer.Handle)`
  background: rgb(212 212 216);
`

export const StyledDialogTitle = styled(Title)`
  display: none;
`
